var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_bank",
    "data-name": "icon/bank",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(16 16)",
    fill: "#1b2b4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_bank_24px",
    "data-name": "icon/bank_24px",
    transform: "translate(22.381 22.381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 20,
    height: 20,
    transform: "translate(-0.381 -0.381)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bank-r",
    transform: "translate(1.221 1.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M7.6,2.25H12.74l6.079,5.364H1.516Zm.468,1.238L4.79,6.376H15.545L12.272,3.488Z",
    transform: "translate(-1.516 -2.25)",
    fill: "#3bb0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M4.25,20.25H17.041v1.238H4.25Z",
    transform: "translate(-1.994 -5.396)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M12.488,17.264V10.25H11.25v7.014Z",
    transform: "translate(-3.218 -3.648)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M16.488,10.25v7.014H15.25V10.25Z",
    transform: "translate(-3.917 -3.648)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M8.488,17.264V10.25H7.25v7.014Z",
    transform: "translate(-2.518 -3.648)",
    fill: "#3bb0ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/icon-bank.3e3a94147b6619af1acb1c16cabf350f.svg";
export { ForwardRef as ReactComponent };